import React from 'react';
import { Route, Routes, Navigate, BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { trTR } from '@mui/material/locale';
import { authHeader } from './services/auth.header';

import HomePage from './pages/HomePage';
import SignInPage from './pages/SingInPage';
import SignUpPage from './pages/SignUpPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmail from './pages/VerifyEmail';
import MapPage from './pages/MapPage';

const THEME = createTheme(
  {
    typography: {
      fontFamily: `Open Sans`,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { minWidth: 0 },
        },
      },
    },
  },
  trTR
);

const PrivatePage = () => {
  const auth = authHeader();
  return auth['x-access-token'] ? <MapPage /> : <Navigate to="/signin" />;
};

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Navigate to="/signin" />} />
        <Route exact path="/signin" element={<SignInPage />} />
        <Route exact path="/signup" element={<SignUpPage />} />
        <Route exact path="/forgotpassword" element={<ForgotPasswordPage />} />
        <Route exact path="/resetpassword" element={<ResetPasswordPage />} />
        <Route exact path="/verifyemail" element={<VerifyEmail />} />
        <Route exact path="/map" element={<PrivatePage />} />
      </Routes>
    </BrowserRouter>
  );
};

const App = () => {
  return (
    <ThemeProvider theme={THEME}>
      <Router />
    </ThemeProvider>
  );
};

export default App;
